/* unplugin-vue-components disabled */import script from "./ProductItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductItem.vue?vue&type=script&lang=ts&setup=true"

import "./ProductItem.vue?vue&type=style&index=0&id=54675a80&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54675a80"]])

export default __exports__